/**
 * Sanitizes Axios / FastAPI / Supabase error payloads into chef-friendly toast
 * strings.  Never leaks raw PostgREST / Supabase JSON to end-users.
 *
 * Rules:
 *   1. If `detail` is a non-empty plain string, return it as-is (FastAPI's
 *      intentional human-readable message).
 *   2. If `detail` is an object / array (Pydantic validation errors,
 *      PostgREST passthroughs, etc.) → return the supplied fallback and
 *      console.error() the raw payload for debugging.
 *   3. If `detail` is a string that looks like JSON (starts with "{" or "[")
 *      or contains a known PostgREST error code (PGRST...) → fallback +
 *      console.error.
 *   4. No `detail` at all → fallback.
 */
const POSTGREST_HINT = /PGRST\d+|"code"\s*:\s*"PGRST/i;
const LOOKS_JSON = /^\s*[{[]/;

export function friendlyError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;

  if (typeof detail === "string" && detail.trim()) {
    if (LOOKS_JSON.test(detail) || POSTGREST_HINT.test(detail)) {
      console.error("[friendlyError] suppressed raw error", detail, err);
      return fallback;
    }
    return detail;
  }

  if (detail && typeof detail === "object") {
    console.error("[friendlyError] suppressed object detail", detail, err);
    return fallback;
  }

  if (err?.message && !err?.response) {
    console.error("[friendlyError] network error", err.message);
  }

  return fallback;
}

export default friendlyError;
